/* eslint-disable import/no-mutable-exports */
// Server-side only implementation
import * as apm from 'elastic-apm-node';

let apmInstance;

// Mock implementation to use in local/ci environments
const mockApmInstance = {
  captureError: () => {},
  setUserContext: () => {},
  setCustomContext: () => {},
  addLabels: () => {},
  startTransaction: () => ({
    end: () => {},
    addLabels: () => {},
  }),
  getCurrentTransaction: () => null,
};

// Check if environment is local or ci
const isLocalOrCi = process.env.ENVIRONMENT === 'local' || process.env.ENVIRONMENT === 'ci';

if (isLocalOrCi) {
  // In local or ci environments, use the mock implementation
  apmInstance = mockApmInstance;
} else {
  // In other environments (dev, staging, prod), try to start the real APM agent
  try {
    apmInstance = apm.start({
      environment: process.env.ENVIRONMENT,
      serviceName: 'product-fe',
      serverUrl: process.env.ELASTIC_APM_SERVER_URL,
      active: true,
    });
  } catch (e) {
    console.warn('Failed to initialize APM Node.js agent', e);
    apmInstance = mockApmInstance;
  }
}

export default apmInstance;
